

import watch from "redux-watch";
import { BaseTag } from "./base_mixin";
import { parse, stringify } from "query-string";
import { BaseAjaxForm }     from 'mixs/base/form_ajax_mixin';
import { POP_STATE }    from 'apps/events';
import serializeJSON    from 'utilities/serialize_json';
import serialize        from 'utilities/serialize';
import { deepmerge }    from 'utilities/merge';
import qs               from 'qs';
import { replaceState } from 'utilities/visit';
import { get }          from "apps/actions/common";
import { Typeahead } from "mixs/inputs/typeahead";
import Tether from "tether";

export class SearchForm extends BaseAjaxForm {
  submitFunction = get;
  public isLoading: boolean = false;
  init(){
    super.init();
  }
  protected submit(){
    super.submit();
    let form   = this.getParamsByForm();
    let search = this.getParamsBySearch();
    let queryObj = deepmerge(search, form);
    let query = serialize(queryObj);
    let uri = this.getNewURI(query);
    if(uri) history.pushState(null, null, uri);
  }
  protected getParamsByForm(){
    let params = {s: serializeJSON(this.formElement())['s']};
    params = parse(serialize(params));
    let newParams = {}
    for(let key in params){
      if(params[key] && params[key] != ''){
        newParams[key] = params[key];
      }
    }
    return newParams;
  }
  protected getParamsBySearch(){
    let params = parse(window.location.search);
    let newParams = {};
    for(let key in params){
      if(/^s\[/.test(key)) continue;
      if(/^page$/.test(key)) continue;
      newParams[key] = params[key];
    }
    return newParams;
  }
}
export class InputsSearchTagsBase extends Typeahead {
}
